var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcSticker16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M8.293 1.293a.93.93 0 0 0-.707-.281A7.002 7.002 0 0 0 8 15a7 7 0 0 0 6.988-6.586.93.93 0 0 0-.28-.707zM7 3.1A5.002 5.002 0 0 0 8 13a5 5 0 0 0 4.9-4A6 6 0 0 1 7 3.1",
  clipRule: "evenodd"
})));
export default SvgIcSticker16;